import { APP_ROUTES } from '../../../constants/routes';
import { TBreacdcrumbData } from './BreadcrumbsBlock.types';

export const HOME_BREADCRUMB: TBreacdcrumbData = {
  label: 'general.breadcrumbs.home',
  to: APP_ROUTES.HOME,
};
